import React, {useEffect, useState} from 'react';
import {
    Route,
    BrowserRouter as Router,
    Switch,
} from "react-router-dom";
import {SignUp, Login, GroupChat, PrivateChat, Friends} from './pages';
import {auth, db} from './services/firebase';
import {PrivateRoute, PublicRoute} from "./hoc/route-type";
import {setOfflineUser} from "./helpers/auth";
import {useTranslation} from "react-i18next";
import {ACCENT_COLORS, THEMES} from "./constants/theme";
import {useThemeDetector} from "./hook/theme-detector";
import {Loader} from "./components";

function App() {

    const [loading, setLoading] = useState(true);
    const [authenticated, setAuthenticated] = useState(false);

    const [t] = useTranslation();
    const isDark = useThemeDetector();

    const unloadHandler = async () => {
        await setOfflineUser(auth().currentUser)
        return 'logout'
    }

    useEffect(() => {

        if(!localStorage.getItem(THEMES.KEY)) {
            localStorage.setItem(THEMES.KEY, THEMES.LIGHT);
        } else {
            switch (localStorage.getItem(THEMES.KEY)) {
                case THEMES.DARK: {
                    document.body.classList.add('dark-mode');
                    break;
                }
                case THEMES.LIGHT: {
                    document.body.classList.remove('dark-mode');
                    break;
                }
                default: {
                    if(isDark) {
                        document.body.classList.add('dark-mode')
                    } else {
                        document.body.classList.remove('dark-mode');
                    }
                }
            }
        }
        if(!localStorage.getItem(ACCENT_COLORS.KEY)) {
            localStorage.setItem(THEMES.KEY, ACCENT_COLORS.BLUE);
        } else {
            switch (localStorage.getItem(ACCENT_COLORS.KEY)) {
                case ACCENT_COLORS.BLUE: {
                   document.documentElement.style.setProperty('--accent-color', 'var(--blue-color)');
                    break;
                }
                case ACCENT_COLORS.PURPLE: {
                   document.documentElement.style.setProperty('--accent-color', 'var(--purple-color)');
                    break;
                }
                case ACCENT_COLORS.RED: {
                   document.documentElement.style.setProperty('--accent-color', 'var(--red-color)');
                    break;
                }
                case ACCENT_COLORS.YELLOW: {
                    document.documentElement.style.setProperty('--accent-color', 'var(--yellow-color)');
                    break;
                }
                case ACCENT_COLORS.GREEN: {
                    document.documentElement.style.setProperty('--accent-color', 'var(--green-color)');
                    break;
                }
                case ACCENT_COLORS.PINK: {
                    document.documentElement.style.setProperty('--accent-color', 'var(--pink-color)');
                    break;
                }
                case ACCENT_COLORS.ORANGE: {
                    document.documentElement.style.setProperty('--accent-color', 'var(--orange-color)');
                    break;
                }
                default: {
                    document.documentElement.style.setProperty('--accent-color', 'var(--blue-color)');
                    break;
                }
            }
        }

        window.addEventListener('beforeunload', unloadHandler);
        window.addEventListener('unload', unloadHandler);
        auth().onAuthStateChanged(async (user) => {
            if (user) {
                setAuthenticated(true);
                await db.ref('users').orderByChild('uid').equalTo(user.uid).once('value', async snapshot => {
                    const key = Object.keys(snapshot.val())[0];
                    if (!snapshot.val()[key].online) {
                        await db.ref(`users/${key}`).set({
                            ...snapshot.val()[key],
                            online: true
                        });
                    }
                })
                setLoading(false);
            } else {
                setAuthenticated(false);
                setLoading(false);
            }
        });

        return () => {
           window.removeEventListener('beforeunload', unloadHandler);
           window.removeEventListener('unload', unloadHandler);
        }
    })

    if (loading) {
        return <Loader />
    }
    return (
        <div id='lng' className={t('direction')}>
            <Router>
                <Switch>
                    <Route exact path="/" component={Login}/>
                    <PrivateRoute path="/group-chat" authenticated={authenticated} component={GroupChat}/>
                    <PrivateRoute path="/private-chat" authenticated={authenticated} component={PrivateChat}/>
                    <PrivateRoute path="/profile" authenticated={authenticated} component={GroupChat}/>
                    <PrivateRoute path="/friends" authenticated={authenticated} component={Friends}/>
                    <PublicRoute path="/signup" authenticated={authenticated} component={SignUp}/>
                    <PublicRoute path="/login" authenticated={authenticated} component={Login}/>
                </Switch>
            </Router>
        </div>
    );
}

export default App;
